module.exports = __webpack_public_path__ + "images/Certificate-V2.png";